import Home from "./Home/Home";
import Investor from "./Investor/Investor";
import PostList from "./Posts/ResearchPosts"
export default function Research() {
    return <main>
        <Home />
        <Investor/>
        <PostList/>
    </main>
}
